var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0652 4.07384H11.3938V3.75955C11.3938 1.76384 9.77523 0.145264 7.77952 0.145264C5.78381 0.145264 4.16523 1.76384 4.16523 3.75955V4.07384H1.49381C1.14613 4.07384 0.865234 4.35473 0.865234 4.70241V15.231C0.865234 15.5787 1.14613 15.8596 1.49381 15.8596H14.0652C14.4129 15.8596 14.6938 15.5787 14.6938 15.231V4.70241C14.6938 4.35473 14.4129 4.07384 14.0652 4.07384ZM5.57952 3.75955C5.57952 2.54366 6.56363 1.55955 7.77952 1.55955C8.99541 1.55955 9.97952 2.54366 9.97952 3.75955V4.07384H5.57952V3.75955ZM13.2795 14.4453H2.27952V5.48812H4.16523V7.21669C4.16523 7.30312 4.23595 7.37384 4.32238 7.37384H5.42238C5.50881 7.37384 5.57952 7.30312 5.57952 7.21669V5.48812H9.97952V7.21669C9.97952 7.30312 10.0502 7.37384 10.1367 7.37384H11.2367C11.3231 7.37384 11.3938 7.30312 11.3938 7.21669V5.48812H13.2795V14.4453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBasket);
export default __webpack_public_path__ + "static/media/ic_basket.3be161ff7e5c0cb94d2880b61efaae36.svg";
export { ForwardRef as ReactComponent };